var _path, _g, _path2, _g2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSum12EmptyUpdated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 24,
    viewBox: "0 0 43 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_845_20586",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.362793 23.0137V0H31.0473V23.0137H0.362793ZM29.287 21.9178L29.7655 17.2603H14.6515L14.4825 19.1781H16.9808L16.7068 21.9178L29.287 21.9178Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_845_20586)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95852 23.0137L5.21768 20.5479L11.3483 17.2603L11.6939 13.9726L1.90038 4.93151L2.24593 1.64384H7.20457L7.37735 0H14.8153H22.2533L22.0805 1.64384H27.0392L26.6936 4.93151L14.9996 13.9726L14.6541 17.2603L20.0936 20.5479L19.8345 23.0137H12.3965H4.95852ZM7.85824 3.28767H4.55248L4.46609 4.10959L7.5127 6.57534L7.85824 3.28767ZM21.0813 3.28767H24.3871L24.3007 4.10959L20.7358 6.57534L21.0813 3.28767Z",
    fill: "#FFB800"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_845_20586",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 0,
    width: 32,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3218 0V3.34439e-05H16.67H24.108L23.9352 1.64387H28.8939L28.5483 4.93154L16.8543 13.9726L16.7679 14.7946L26.3015 14.7947L25.457 23.0137H42.0063V0H11.3218ZM13.4622 14.7946L11.3218 14.7946V11.9169L13.5486 13.9726L13.4622 14.7946Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_845_20586)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6353 23.0137L19.8944 20.5479L26.0251 17.2603L26.3706 13.9726L16.5771 4.93151L16.9227 1.64384H21.8813L22.0541 0H29.4921H36.93L36.7573 1.64384H41.7159L41.3704 4.93151L29.6764 13.9726L29.3308 17.2603L34.7704 20.5479L34.5112 23.0137H27.0732H19.6353ZM22.535 3.28767H19.2292L19.1428 4.10959L22.1895 6.57534L22.535 3.28767ZM35.7581 3.28767H39.0638L38.9774 4.10959L35.4125 6.57534L35.7581 3.28767Z",
    fill: "#D9D7CF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4385 17.6687L16.6566 15.5357H19.3714L19.6865 12.6028H21.9649L21.6498 15.5357H24.3403L24.1222 17.6687H21.4317L21.1166 20.6016H18.8381L19.1532 17.6687H16.4385Z",
    fill: "#798BB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSum12EmptyUpdated);
export default __webpack_public_path__ + "static/media/sum-1-2-empty-updated.f3446a60978de0999f2cdab3e1fcf485.svg";
export { ForwardRef as ReactComponent };